import { render } from "./ImgAvatar.vue?vue&type=template&id=42e02a00"
import script from "./ImgAvatar.vue?vue&type=script&lang=js"
export * from "./ImgAvatar.vue?vue&type=script&lang=js"

import exportComponent from "/Users/yenneelim/Development/signon_static/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__